import React, { useEffect, useState } from "react";
import { Button, Input, Label, ButtonGroup } from "reactstrap";
import { imprezyService } from "../../service/Imprezy";
import MainLoader from "../../components/MainLoader";
import Impreza from "../../components/Impreza";
import ImprezaDetails from "../../components/ImprezaDetails";
import Popup from "../../components/Popup";
import Ranga from "../../enums/Ranga";
import { DataContextProvider } from "../../context/DataContext";

const blankDraft = (sezon) => ({
  Id: "",
  Sezon: sezon,
  Nazwa: "",
  TerminOd: "",
  TerminDo: "",
  WasCancelled: 0,
  Miejsce: "",
  Wojewodztwo: "",
  Logo: "",
  Links: [],
  Etapy: [],
  Organizatorzy: []
});

const ImprezyAdmin = () => {
  const [imprezy, setImprezy] = useState([]);
  const [filteredImprezy, setFilteredImprezy] = useState([]);
  const [loading, setLoading] = useState(true);
  const [sezon, setSezon] = useState(new Date().getFullYear());
  const [rangaFilter, setRangaFilter] = useState("");
  const [createOpen, setCreateOpen] = useState(false);
  const [createDraft, setCreateDraft] = useState(blankDraft(new Date().getFullYear()));

  const fetchData = () => {
    setLoading(true);
    imprezyService.getList(sezon).then((response) => {
      setImprezy(response.data ?? []);
      setLoading(false);
    });
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    rangaFilter
      ? setFilteredImprezy(imprezy.filter((x) => x.Rangi.indexOf(rangaFilter) !== -1))
      : setFilteredImprezy(imprezy);
  }, [imprezy, rangaFilter]);

  if (loading) return <MainLoader />;

  const updateImpreza = (imprezaDetails) => {
    if (!imprezaDetails?.Id) {
      return;
    }

    setImprezy((prev) =>
      prev.map((item) => {
        if (item.Id !== imprezaDetails.Id) {
          return item;
        }

        return {
          ...item,
          ...imprezaDetails
        };
      })
    );
  };

  const handleCreateOpen = () => {
    const draftSeason = Number(sezon) || new Date().getFullYear();
    setCreateDraft(blankDraft(draftSeason));
    setCreateOpen(true);
  };

  const handleCreateSave = () => {
    imprezyService.saveImpreza(createDraft).then(() => {
      setCreateOpen(false);
      fetchData();
    });
  };

  return (
    <DataContextProvider>
      <div className="inline-container">
        <Label for="sezon">Sezon</Label>
        <Input
          style={{ maxWidth: "100px" }}
          type="number"
          value={sezon}
          name="sezon"
          onChange={(e) => setSezon(e.target.value)}
        />
        <Button
          disabled={!sezon}
          color="primary"
          className="mb-6"
          size="md"
          type="button"
          onClick={fetchData}
        >
          Szukaj
        </Button>
      </div>
      <div className="inline-container">
        <Label for="filtry">Pokaż tylko</Label>
        <ButtonGroup>
          <Button
            color="success"
            outline
            onClick={() => setRangaFilter(Ranga.MP.key)}
            active={rangaFilter == Ranga.MP.key}
          >
            {Ranga.MP.value}
          </Button>
          <Button
            color="success"
            outline
            onClick={() => setRangaFilter(Ranga.PP.key)}
            active={rangaFilter == Ranga.PP.key}
          >
            {Ranga.PP.value}
          </Button>
          <Button
            color="success"
            outline
            onClick={() => setRangaFilter(Ranga.PPM.key)}
            active={rangaFilter == Ranga.PPM.key}
          >
            {Ranga.PPM.value}
          </Button>
          <Button
            color="success"
            outline
            onClick={() => setRangaFilter("")}
            active={!rangaFilter}
          >
            Wszystkie
          </Button>
        </ButtonGroup>
      </div>
      <div className="inline-container mb-2">
        <Button color="primary" onClick={handleCreateOpen}>
          Dodaj imprezę
        </Button>
      </div>
      {(!filteredImprezy || !filteredImprezy.length) && <div>Brak imprez spełniających kryteria</div>}
      {filteredImprezy && filteredImprezy.length > 0 && (
        <div className="grid-container mt-2">
          {filteredImprezy.map((ino) => (
            <Impreza key={ino.Id} ino={ino} isAdmin={true} update={updateImpreza} />
          ))}
        </div>
      )}
      {createOpen && (
        <Popup
          cancel={() => setCreateOpen(false)}
          title="Nowa impreza"
          submit={handleCreateSave}
          showSubmit={true}
        >
          <ImprezaDetails
            details={createDraft}
            admin={true}
            onDraftChange={setCreateDraft}
          />
        </Popup>
      )}
    </DataContextProvider>
  );
};

export default ImprezyAdmin;
